module.exports = __webpack_public_path__ + "static/media/IMG_2931.23f63bde.jpg";